import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl, FormattedMessage } from "react-intl";
//
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import featureDisplay from "../../../../common/utils/featureDisplay";
//
import DividerImage from "../../../../../images/home_divier/home_divier.svg";
import HomeCard from "../common/HomeCard";
//
import HomeMultiShapeImg from "../../../../../images/home_basemap_multi_shape/home_basemap_multi_shape@2x.png";
//
import { cardSetting } from "./option";
// style

const StyledBgBox = styled(
  Box,
  {}
)(({ theme }) => ({
  backgroundImage: `url("${HomeMultiShapeImg}")`,
  width: "100%",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
}));

const OutServiceSec = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  return (
    <StyledBgBox>
      <Container sx={{ paddingBottom: "32px" }}>
        <Grid
          container
          flexWrap="wrap"
          justifyContent="center"
          rowSpacing={{ xs: 6, sm: 6, md: 6 }}
          columnSpacing={{ xs: 6, sm: 6, md: 6 }}
          sx={{
            paddingX: "88px",
          }}
        >
          <Grid item xs={12} justifyContent="center">
            <Box display="flex" justifyContent="center">
              <img
                src={DividerImage}
                width={40}
                height={8}
                alt="home divider"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "32px", marginBottom: "56px" }}>
            <Box mb={6}>
              <Typography textAlign="center" variant="h3">
                <FormattedMessage
                  id="home.ourservice.title"
                  defaultMessage="我們的服務"
                />
              </Typography>
            </Box>
            <Typography textAlign="center" variant="h6">
              <FormattedMessage
                id="home.ourservice.introduction"
                defaultMessage="數位人文工具的新選項，邀你一同進入數位人文的領域"
              />
            </Typography>
          </Grid>
          {cardSetting.map((card, idx) => (
            <Grid key={idx.toString()} item xs={12} sm={12} md={6}>
              <HomeCard
                title={card.title}
                content={card.content}
                imgSrc={card.imgSrc}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </StyledBgBox>
  );
};

OutServiceSec.propTypes = {};

OutServiceSec.defaultProps = {};

export default OutServiceSec;
